@if (photoUrls().length > 0) {
  <div class="attachment-strip" [attr.data-testid]="'attachments-' + entityType() + '-' + entityId()">
    <app-photo-thumbnail [photos]="photoUrls()" />
  </div>
}
